import styled from 'styled-components'

export const Container = styled.div`
  background-color: #FCF8EF;
  padding: 124px 62px;

  @media (max-width: 911px) {
    padding: 62px 24px;
  }
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-inline: auto;
  max-width: 1366px;
  width: 100%;

  & > figure {
    border-radius: 62px;
    box-shadow: 0px 0px 62px 0px #00A9883D;
    max-width: 683px;
    overflow: hidden;
    position: relative;

    & > img {
      width: 100%;
    }

    & > figcaption {
      bottom: 24px;
      color: #FFF;
      font-size: 1rem;
      font-style: italic;
      font-weight: 300;
      line-height: 120%;
      position: absolute;
      right: 40px;
    }
  }

  @media (max-width: 911px) {
    flex-direction: column;
    gap: 80px;
  }

  @media (max-width: 568px) {
    & > figure {
      & > figcaption {
        bottom: 12px;
        left: 0;
        right: 0;
        margin-inline: auto;
        width: fit-content;
      }
    }
  }
`

export const TextContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 62px;
  max-width: 453px;
  width: 100%;

  @media (max-width: 911px) {
    max-width: 683px;
  }

  @media (max-width: 568px) {
    align-items: initial;
    gap: 32px;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  & > h1 {
    color: #084F43;
    font-size: 3rem;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -1px;
  }

  & > p {
    color: #084F43;
    font-size: 1.5rem;
    font-weight: 400;
  }

  @media (max-width: 568px) {
    & > h1 {
      font-size: 2rem;
    }

    & > p {
      font-size: 1rem;
    }
  }
`
